<template>
    <div>
        <hero-bar :has-right-visible="true" menu-icon="desktop-mac">
            {{ $lang.Calculation.Title }}
            <span class="subtitle hero-subtitle">{{ $lang.Calculation.NewTitle_3 }}</span>
            <p class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-catalog-request" icon-left="plus-box-outline" @click="openCircuitDevices">{{ [$lang.Calculation.InnerTitle_14, $lang.Calculation.InnerTitle_15, $lang.Calculation.InnerTitle_16].join(' ') }}</b-button>
            </p>
            <p class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-gray" @click="previous">{{ $lang.Menus.BackBtn }}</b-button>
            </p>
            <p class="control" slot="right">
                <b-button class="button is-primary" @click="submit">{{ $lang.Menus.ContinueBtn }}</b-button>
            </p>
        </hero-bar>

        <div class="wizard">
            <div class="wizard-rail">
                <verticalStep-bar />
            </div>

            <div class="wizard-body calc-body">
                <calculationTabs />
                <outputCircBtns />

                <div class="wizard-card">
                    <p class="wizard-card-head">{{ $lang.CalcCircInfos.Title_13 }}</p>
                    <div class="calc-grid">
                        <b-field class="is-span-two" :label="$lang.CalcCircInfos.Explanation" :type="{ 'is-danger': hasError_explanation }" :message="hasError_explanation ? $lang.Menus.EmptyWarning : ''">
                            <b-input v-model="explanation"></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.LostPower_2" :type="{ 'is-danger': hasError_lostPower }" :message="hasError_lostPower ? (lostPower === '' ? $lang.Menus.EmptyWarning : $lang.Menus.PositiveWarning) : ''">
                            <b-input v-model="lostPower" type="number" step="any" min="0"></b-input>
                        </b-field>
                    </div>
                    <div class="calc-actions">
                        <b-button type="is-success" :label="$lang.CalcCircInfos.CalcAddButton" @click="addToManuelCalcDevices" />
                    </div>
                </div>

                <template v-if="calcdevicesdata.length != 0">
                    <p class="wizard-card-head">{{ $lang.CalcCircInfos.Title_7 }}</p>
                    <div class="calc-table-card">
                        <b-table class="data-table is-flush" :data="calcdevicesdata">
                            <b-table-column field="Explanation" :label="$lang.CalcCircInfos.TableDefinition" v-slot="props" cell-class="cell-strong">
                                {{ props.row.Explanation }}
                            </b-table-column>
                            <b-table-column field="LostPower" width="160" numeric>
                                <template v-slot:header=""><span v-html="$lang.CalcCircInfos.LostPower_3"></span></template>
                                <template v-slot="props">{{ truncate(props.row.LostPower, 1) }}</template>
                            </b-table-column>
                            <b-table-column field="Action" v-slot="props" width="164">
                                <div class="row-actions">
                                    <button class="button row-action" :title="$lang.MyProjects.Edit" @click="openManuelCalcDeviceModal(props.row)">
                                        <span class="mdi mdi-pencil" aria-hidden="true"></span>
                                    </button>
                                    <button class="button row-action is-destructive" :title="$lang.MyProjects.Delete" @click="deleteFromManuelCalcDevices(props.row)">
                                        <span class="mdi mdi-delete" aria-hidden="true"></span>
                                    </button>
                                    <button class="button row-action" :title="$lang.MyProjects.Copy" @click="copyFromManuelCalcDevices(props.row)">
                                        <span class="mdi mdi-content-copy" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </b-table-column>
                        </b-table>
                        <div class="calc-total">
                            <span>{{ $lang.CalcCircInfos.Total_P_Manuel }}</span>
                            <b>{{ truncate(total_P, 1) }}</b>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <!-- Edit an additional power. It shares the add form's fields; the form is kept and given back. -->
        <b-modal v-model="isCalcDeviceUpdateModalActive" has-modal-card @close="restoreForm">
            <div class="modal-card calc-modal">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ $lang.CalcCircInfos.UpdatePManuel }}</p>
                </header>
                <section class="modal-card-body">
                    <div class="calc-grid is-two">
                        <b-field :label="$lang.CalcCircInfos.Explanation" :type="{ 'is-danger': hasError_explanation }" :message="hasError_explanation ? $lang.Menus.EmptyWarning : ''">
                            <b-input v-model="explanation"></b-input>
                        </b-field>
                        <b-field :label="$lang.CalcCircInfos.LostPower_2" :type="{ 'is-danger': hasError_lostPower }" :message="hasError_lostPower ? (lostPower === '' ? $lang.Menus.EmptyWarning : $lang.Menus.PositiveWarning) : ''">
                            <b-input v-model="lostPower" type="number" step="any" min="0"></b-input>
                        </b-field>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <b-button :label="$lang.Menus.ModalCloseBtn" @click="closeUpdateModal" />
                    <b-button :label="$lang.Menus.ModalUpdtBtn" type="is-primary" @click="updateManuelCalcDevices()" />
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import { storeLossTotals } from '@/api/lossTotals';
    import VerticalStepBar from '@/components/VerticalStepBar.vue';
    import OutputCircBtns from '@/components/OutputCircBtns.vue';
    import CalculationTabs from '@/components/CalculationTabs.vue';
    import keepFormDuringEdit from '@/mixins/keepFormDuringEdit';

    export default {
        name: 'Calc_Manuel',
        mixins: [keepFormDuringEdit],
        components: {
            VerticalStepBar,
            OutputCircBtns,
            CalculationTabs
        },
        data() {
            return {
                isActive: true,
                labelPosition: 'on-border',
                projectId: 0,
                manuelCalcDeviceId: 0,
                calcdevicesdata: [],
                explanation: '',
                total_P: 0,
                lostPower: 0,
                isCalcDeviceUpdateModalActive: false,
                hasError_explanation: false,
                hasError_lostPower: false,
                canCalculate: false
            }
        },
        mounted() {
            this.projectId = this.$store.state.projectId;
            this.getManuelCalcDevicesTable();

            this.$store.state.activeStep = 3;
            this.$store.state.isFooterFixed = false;
        },
        watch: {
            $route() {

            }
        },
        methods: {
            previous() {
                this.$store.isPageOpenedFromStepBar = false;

                router.push('/calc_OutputCircuit');
            },
            // The add form is not checked here: it flashed red and went on anyway.
            submit() {
                this.saveResult();

                this.$store.isPageOpenedFromStepBar = false;
                this.$store.canResultOpen = true;

                router.push('/calc_Summary');
            },
            // The whole tool's total, from the server: see api/lossTotals.js.
            saveResult() {
                return storeLossTotals(this.$store, this.projectId).catch(() => {});
            },
            controlInputs() {
                // Cleared on every check: it used to stay true after the first good add, so a
                // later add with empty fields went through.
                this.canCalculate = false;
                if (this.explanation == '') {
                    this.hasError_explanation = true;
                } else if (!(parseFloat(this.lostPower) > 0)) {
                    this.hasError_lostPower = true;
                } else {
                    this.canCalculate = true;
                }

                if (this.explanation != '') {
                    this.hasError_explanation = false;
                }
                if (parseFloat(this.lostPower) > 0) {
                    this.hasError_lostPower = false;
                }
            },
            getManuelCalcDevicesTable() {
                this.calcdevicesdata = [];
                api.panels.getManuelCalcDevices(this.projectId).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        res.data.forEach((e) => {
                            this.calcdevicesdata.push(e);
                        });

                        api.panels.getTotal_P_OtherPowerCalculationDevices(this.projectId).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.total_P = res.data;
                                this.saveResult();
                            }
                        });
                    }
                });
            },
            addToManuelCalcDevices() {
                this.controlInputs();

                if (this.canCalculate) {
                    var device = {
                        ProjectId: this.projectId,
                        Explanation: this.explanation,
                        LostPower: this.lostPower
                    };

                    api.panels.addToManuelCalcDevices(device).then((res) => {
                        if (res.isError) {
                            this.$buefy.dialog.alert(this.$errorModal(res));
                        } else {
                            this.$buefy.toast.open(this.$lang.OtherDialog.Added);
                            this.getManuelCalcDevicesTable();
                            this.explanation = '';
                            this.lostPower = '';
                        }
                    });
                }
            },
            deleteFromManuelCalcDevices(device) {
                this.$buefy.dialog.confirm({
                    title: this.$lang.DeleteDialog.Title,
                    message: this.$lang.DeleteDialog.Message,
                    confirmText: this.$lang.DeleteDialog.Confirm,
                    cancelText: this.$lang.DeleteDialog.Cancel,
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () =>

                        api.panels.deleteFromManuelCalcDevices(device).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$buefy.toast.open(this.$lang.DeleteDialog.Deleted);
                                this.getManuelCalcDevicesTable();
                            }
                        })
                })
            },
            copyFromManuelCalcDevices(device) {
                var initialDefinition = device.Explanation;
                device.Explanation = device.Explanation + " " + this.$lang.CopyDialog.Extension;
                this.$buefy.dialog.confirm({
                    title: this.$lang.CopyDialog.Title,
                    message: this.$lang.CopyDialog.Message,
                    confirmText: this.$lang.CopyDialog.Confirm,
                    cancelText: this.$lang.CopyDialog.Cancel,
                    type: 'is-warning',
                    hasIcon: true,
                    onConfirm: () =>

                        api.panels.addToManuelCalcDevices(device).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$buefy.toast.open(this.$lang.CopyDialog.Copied);
                                this.getManuelCalcDevicesTable();
                            }
                        }),
                    onCancel: () => {
                        device.Explanation = initialDefinition;
                    }
                })
            },
            openManuelCalcDeviceModal(device) {
                this.keepForm(['explanation', 'lostPower', 'hasError_explanation', 'hasError_lostPower']);
                this.manuelCalcDeviceId = device.Id;
                this.isCalcDeviceUpdateModalActive = true;
                this.explanation = device.Explanation;
                this.lostPower = device.LostPower;
            },
            closeUpdateModal() {
                this.isCalcDeviceUpdateModalActive = false;
                this.restoreForm();
            },
            updateManuelCalcDevices() {
                // The same checks as an add; the dialog used to save whatever it held.
                this.controlInputs();
                if (!this.canCalculate) {
                    return;
                }
                const device = {
                    Id: this.manuelCalcDeviceId,
                    ProjectId: this.projectId,
                    Explanation: this.explanation,
                    LostPower: this.lostPower,
                };
                api.panels.updateManuelCalcDevices(device).then((res) => {
                    if (res.isError) {
                        this.$buefy.dialog.alert(this.$errorModal(res));
                    } else {
                        this.closeUpdateModal();
                        this.$buefy.toast.open(this.$lang.OtherDialog.Updated);
                        this.getManuelCalcDevicesTable();
                    }
                });
            },
            truncate(numToBeTruncated, numOfDecimals) {
                var theNumber = numToBeTruncated.toString();
                if (theNumber.includes('.')) {
                    var pointIndex = theNumber.indexOf('.');
                    var _result = +(theNumber.slice(0, pointIndex > -1 ? ++numOfDecimals + pointIndex : undefined));
                    var _resultString = _result.toString();
                    if (!_resultString.includes('.')) {
                        return _resultString + '.0';
                    } else {
                        return _result;
                    }
                } else {
                    return theNumber + '.0';
                }
            },
            columnTdAttrs(row, column) {
                if (row.id === 'Total') {
                    if (column.label === 'ID') {
                        return {
                            colspan: 4,
                            class: 'has-text-weight-bold',
                            style: {
                                'text-align': 'left !important'
                            }
                        }
                    } else if (column.label === 'Gender') {
                        return {
                            class: 'has-text-weight-semibold'
                        }
                    } else {
                        return {
                            style: { display: 'none' }
                        }
                    }
                }
                return null
            },
            openCircuitDevices() {
                this.$store.state.previousRoute = this.$route.name;
                this.$store.state.isCircDevicesFromCalculation = true;
                if (this.$store.state.memberId != 'TestMember' && this.$store.state.isAdmin == 1) {
                    router.push('/circuitDevices_Admin');
                } else {
                    router.push('/circuitDevices');
                }
            }
        },

    };
</script>
